module.exports = __webpack_public_path__ + "media/images/flags/1x1/nld-25edbf37ef729d8f54156c9ebe38e8d6.svg";